import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url";

const client = createClient({
  projectId: "arynqonz",
  dataset: "production",
  useCdn: true,
  apiVersion: "2024-01-01",
});

export function sanityFetch<T>(query: string): Promise<T> {
  return (client as any).fetch(query);
}

const builder = imageUrlBuilder(client);

export function sanityImageUrl(source: SanityImageSource) {
  return builder.image(source).url();
}

export default client;
